import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { api } from '../services/api'

export default function Footer() {
  const currentYear = new Date().getFullYear()
  const [citiesByState, setCitiesByState] = useState({})
  const [expanded, setExpanded] = useState(false)

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const response = await api.locations.getCities()
        if (response?.cities_by_state) {
          setCitiesByState(response.cities_by_state)
        }
      } catch (error) {
        // Silently fail — footer nav is non-critical
      }
    }
    fetchCities()
  }, [])

  const states = Object.keys(citiesByState).sort()
  const hasStates = states.length > 0

  return (
    <footer className="bg-bg-elevated border-t border-border transition-colors duration-200">
      {/* Super Nav: Cities by State */}
      {hasStates && (
        <div className="border-b border-border">
          <div className="app-container py-8">
            <button
              onClick={() => setExpanded(!expanded)}
              className="flex items-center gap-2 text-sm font-semibold text-text uppercase tracking-wide mb-6 hover:text-primary-600 transition-colors"
            >
              Garage Sales by City
              <svg
                className={`h-4 w-4 transition-transform ${expanded ? 'rotate-180' : ''}`}
                fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
              </svg>
            </button>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-x-6 gap-y-6">
              {states.map((state) => (
                <div key={state}>
                  <h3 className="text-sm font-semibold text-text mb-2">{state}</h3>
                  <ul className="space-y-1">
                    {citiesByState[state].map((entry) => (
                      <li key={entry.city}>
                        <Link
                          to={`/cities/${encodeURIComponent(`${entry.city}, ${state}`)}`}
                          className="text-sm text-text-muted hover:text-primary-600 transition-colors"
                        >
                          {entry.city}
                          <span className="text-text-muted/60 ml-1">({entry.sales_count})</span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Bottom bar */}
      <div className="app-container py-6">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <div className="text-sm text-text-muted">
            &copy; {currentYear} AppCerc LLC. All rights reserved.
          </div>
          <div className="flex items-center gap-6">
            <Link to="/terms" className="link-subtle text-sm">
              Terms of Service
            </Link>
            <Link to="/privacy" className="link-subtle text-sm">
              Privacy Policy
            </Link>
          </div>
        </div>
        <div className="mt-4 text-center text-xs text-text-muted">
          Websites and Apps developed locally in Elkhart County, IN by{' '}
          <a href="https://appcerc.com" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:text-primary-700 transition-colors">
            Appcerc LLC
          </a>
        </div>
      </div>
    </footer>
  )
}
